import { useState } from "react";
import { Send, MessageCircle, Mail, Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useSettings } from "@/context/SettingsContext";
import { SectionHeading } from "@/components/Section";
import { toast } from "sonner";

export default function ContactPage() {
  const { t } = useI18n();
  const { settings } = useSettings();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) { toast.error(apiError(err)); }
    setLoading(false);
  };

  return (
    <div className="section-lux grid-glow">
      <div className="container-lux grid lg:grid-cols-2 gap-12">
        <div>
          <SectionHeading label="Contact" title={t("contact.title")} subtitle={t("contact.sub")} center={false} />
          <div className="mt-8 space-y-4">
            {settings.contact_email && (
              <a href={`mailto:${settings.contact_email}`} className="card-lux p-5 flex items-center gap-4 hover:border-amber-500/40" data-testid="contact-email-link">
                <Mail className="text-amber-400" size={22} />
                <div><div className="text-xs text-slate-500">Email</div><div className="text-white font-medium">{settings.contact_email}</div></div>
              </a>
            )}
            <div className="grid grid-cols-2 gap-4">
              {settings.telegram && (
                <a href={settings.telegram} target="_blank" rel="noreferrer" className="card-lux p-5 flex items-center gap-3 hover:border-amber-500/40" data-testid="contact-telegram">
                  <Send className="text-sky-400" size={20} /><span className="text-white font-medium">Telegram</span>
                </a>
              )}
              {settings.whatsapp && (
                <a href={settings.whatsapp} target="_blank" rel="noreferrer" className="card-lux p-5 flex items-center gap-3 hover:border-amber-500/40" data-testid="contact-whatsapp">
                  <MessageCircle className="text-emerald-400" size={20} /><span className="text-white font-medium">WhatsApp</span>
                </a>
              )}
            </div>
          </div>
        </div>
        <form onSubmit={submit} className="card-lux p-7 space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="label-lux">{t("contact.name")}</label><input required className="input-lux mt-2" value={form.name} onChange={set("name")} data-testid="contact-name-input" /></div>
            <div><label className="label-lux">{t("contact.email")}</label><input required type="email" className="input-lux mt-2" value={form.email} onChange={set("email")} data-testid="contact-email-input" /></div>
          </div>
          <div><label className="label-lux">{t("contact.subject")}</label><input className="input-lux mt-2" value={form.subject} onChange={set("subject")} data-testid="contact-subject-input" /></div>
          <div><label className="label-lux">{t("contact.message")}</label><textarea required rows={5} className="input-lux mt-2 resize-none" value={form.message} onChange={set("message")} data-testid="contact-message-input" /></div>
          <button disabled={loading} className="gold-btn w-full" data-testid="contact-submit-btn">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <>{t("contact.send")} <Send size={16} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
